import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { SlSelect } from '@shoelace-style/shoelace';

@Component({
  selector: 'app-single-select',
  templateUrl: './single-select.component.html',
  styleUrls: ['./single-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[id]': 'id',
  }
})
export class SingleSelectComponent extends FieldType<FieldTypeConfig> implements AfterViewInit {

  @ViewChild("select") select!: ElementRef<SlSelect>;

  get clearable(): boolean {
    const clearableProp = this.props["clearable"];
    if (typeof clearableProp === 'boolean') {
      return clearableProp;
    }
    // whenever clearable is not informed, true is to be the default value.
    return true;
  }

  ngAfterViewInit(): void {
    // This is a workaround for setting the default selected values since Shoelace has a bug reported
    // on the default values not being set. We will keep an eye out for a fix for this.
    if (this.select?.nativeElement) {
      this.select.nativeElement.setAttribute("value", this.field.defaultValue)
    }
  }

  getOptions(): any[] {
    // It's safe to assume `prop.options` is type `any[]` since we pass in the values via API to the prop options
    return this.props.options as any[];
  }

  onSelectionChange(event: CustomEvent) {
    const value: string = (event.target as SlSelect).value as string;
    this.formControl.setValue(value);
    this.formControl.markAsDirty();
    this.formControl.markAsTouched();
    this.formControl.updateValueAndValidity();
  }
}
